import { CurrencyValue } from '@dfl/mui-react-common';
import { SxProps } from '@mui/material';
import { PercentValue } from 'components/libs/PercentValue';
import { useCurrency } from 'contexts/CurrencyProvider';
import { memo } from 'react';
import classNames from 'classnames';

type PriceCellProps = {
  value: any;
  sx?: SxProps;
};

const PriceCell = ({ value, sx }: PriceCellProps) => {
  const { primary } = useCurrency();

  if (value?.type === 'PERCENT') {
    return <PercentValue sx={sx} value={value?.value || 0} />;
  }
  if (value?.type === 'FIXED') {
    return <CurrencyValue sx={sx} value={value?.value || 0} currency={primary} />;
  }
  return <CurrencyValue sx={sx} value={value || 0} currency={primary} className={classNames({ 'text-danger': value < 0 })} />;
};

export default memo(PriceCell);
